import intance from '../util/axios';

export const UserData = async (page = 1, limit = 10, q, startDate, endDate, filterValue, headers) => {
  let URL = `admin_user/v1/user-list?pagination=yes&page=${page}&limit=${limit}`;

  if (q) URL += `&q=${q}`;
  if (startDate) URL += `&start_date=${startDate}`;
  if (endDate) URL += `&end_date=${endDate}`;
  if (filterValue) URL += `&role=${filterValue}`;

  console.log('url..', URL);
  const response = await intance.get(URL, { headers });
  console.log('response...', response.data);
  return response.data;
};

export const UserDetailsAction = async (value, headers) => {
  let URL = `admin_user/v1/accept-reject-user`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const UserStatus = async (value, headers) => {
  let URL = `admin_user/v1/active-deactive-account`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const UserDetailsById = async (id, value, headers) => {
  let URL = `admin_user/v1/user-detail/${id}`;
  const response = await intance.get(URL, value, { headers });
  return response;
};

export const reportData = async (id) => {
  let URL = `admin_user/v1/revenue-summary/pdf/get/${id}`;
  const response = await intance.get(URL, { responseType: 'blob' });
  return response;
};

export const PromoCode = async (value, headers) => {
  let URL = `order/v1/add-promo-code`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const updateProfile = async (id, value, headers) => {
  let URL = `admin/v1/update-user-profile/${id}`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const changePassword = async (id, value, headers) => {
  let URL = `admin/v1/update-password/${id}`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const sendChatNotification = async (value, headers) => {
  let URL = `order/v1/send-notification`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const Logout = async (value, headers) => {
  let URL = `user/v1/logout`;
  const response = await intance.get(URL, value, { headers });
  return response;
};
